import { Modal } from 'react-bootstrap'
import { Condicionante } from '../../models'

type Props = {
  condicionanteRecuperadaPorId?: Condicionante
  titulo?: string
  cerrarModal: () => void
}

export const ModalCondicionanteHeader = ({
  condicionanteRecuperadaPorId,
  titulo,
  cerrarModal,
}: Props) => {
  // Header de modal: muestra titulo (contexto) y, cuando existe, el nombre de la condicionante.
  return (
    <Modal.Header>
      <div className='align-items-center d-flex flex-grow-1 '>
        {titulo ? <h4 className='modal-tittle'>{titulo}</h4> : ''}
        {condicionanteRecuperadaPorId?.nombre ? (
          <span className='text-muted fw-lighter fs-4 ps-2 d-flex'>
            | {condicionanteRecuperadaPorId?.nombre}{' '}
          </span>
        ) : (
          ''
        )}
      </div>
      <button
        className=' close btn  btn-outline-dark btn-icon btn-circle btn-sm ms-5 d-flex col-12 '
        onClick={cerrarModal}>
        <i className='fa-solid fa-plus fs-1' style={{ rotate: '45deg' }}></i>
      </button>
      </Modal.Header>
  )
}
